export default __webpack_public_path__ + "media/images/colored-logo-0523689329df3bec570233bbb4ffffba.png";